module.exports = __webpack_public_path__ + "static/media/preview.0c16d81f.png";